/**
 * @file コンポーネント：プライバシーポリシー ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnGetCultureLanguage } from "~/src/functions/common";

// コンポーネントを返す
export const Privacypolicy = (props) => {
    // UI言語
    const languageCode = fnGetCultureLanguage();

    /**
     * プライバシーポリシーコンテナを最後までスクロールしたら同意をチェックできるようにする
     */
    const refContainerEn = useRef(null);
    const refContainerJa = useRef(null);
    const refFrameEn = useRef(null);
    const refFrameJa = useRef(null);
    const [isReaded, setIsReaded] = useState(false);
    useEffect(() => {
        const arrayRefContainer = [refContainerEn, refContainerJa];
        const arrayRefFrame = [refFrameEn, refFrameJa];
        arrayRefContainer.forEach((_, index) => {
            const refContainer = arrayRefContainer[index];
            const refFrame = arrayRefFrame[index];
            if (
                refContainer &&
                refContainer.current &&
                refFrame &&
                refFrame.current
            ) {
                refFrame.current.addEventListener("scroll", () => {
                    const position = refFrame.current.scrollTop;
                    const heightFrame = refFrame.current.clientHeight;
                    const heightContainer = refContainer.current.clientHeight;
                    // 端数で正常動作しない場合があるので10引いておく
                    if (position >= heightContainer - heightFrame - 10) {
                        setIsReaded(true);
                    }
                });
            }
        });
    }, [refContainerEn, refContainerJa, refFrameEn, refFrameJa]);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            isReaded={isReaded}
            languageCode={languageCode}
            refContainerEn={refContainerEn}
            refContainerJa={refContainerJa}
            refFrameEn={refFrameEn}
            refFrameJa={refFrameJa}
        />
    );
};
